"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.api = void 0;

var _map = _interopRequireDefault(require("./map"));

var _layerConfig = _interopRequireDefault(require("./layerConfig"));

var _reportConfig = _interopRequireDefault(require("./reportConfig"));

var _messagesConfig = _interopRequireDefault(require("./messagesConfig"));

var _visibilityConfig = _interopRequireDefault(require("./visibilityConfig"));

var _permissions = _interopRequireDefault(require("./permissions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import origin from '../lib/origin';
// const BASE_URL = origin();


var api = {
  iamApi: {
    host: 'https://iam.kubra.io/api/v1'
  }
};
exports.api = api;
var googleAnalyticsCode = 'UA-110840836-3';
var _default = {
  api: api,
  googleAnalyticsCode: googleAnalyticsCode,
  mapConfig: _map.default,
  layersConfig: _layerConfig.default,
  reportsConfig: _reportConfig.default,
  messagesConfig: _messagesConfig.default,
  visibilityConfig: _visibilityConfig.default,
  permissions: _permissions.default
};
exports.default = _default;